// SummitNotThisYearPage — the confirmation a reader lands on after clicking
// "Not going to make this year's Summit? Let us know here" in the NA Summit
// promo emails (thread mct_ad39834d-8ea). The suppression itself happens
// upstream (the EE smart link adds the contact to HubSpot list 19532), so the
// page is static: no form, no data stored, no API call.

import type { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import TakerShell from './components/TakerShell';

const h1: CSSProperties = { fontFamily: "'Fraunces', serif", fontSize: 36, fontWeight: 900, color: '#0A0A2E', lineHeight: 1.1, margin: '0 0 16px' };
const p: CSSProperties = { fontSize: 17, color: '#44445e', lineHeight: 1.55, margin: '0 0 16px' };
const btn: CSSProperties = { display: 'inline-block', background: '#F05A28', color: '#fff', borderRadius: 10, padding: '13px 22px', fontWeight: 700, fontSize: 16, textDecoration: 'none' };

export function SummitNotThisYearPage() {
  return (
    <TakerShell footerLabel="The Successful Bookkeeper">
      <div style={{ maxWidth: 640, margin: '0 auto', padding: '56px 16px 96px' }}>
        <h1 style={h1}>Got it, no more Summit emails.</h1>
        <p style={p}>Thanks for letting us know. We won't send you any more emails about this year's Summit.</p>
        <p style={p}>You'll still hear from us about everything else.</p>
        <p style={{ ...p, marginBottom: 28 }}>If you change your mind, you can still grab a free seat.</p>
        <Link to="/events/summit-2026-na" style={btn}>Take me to the Summit page</Link>
      </div>
    </TakerShell>
  );
}
